module.exports = __webpack_public_path__ + "static/media/mp_male.bcfcfab6.png";